import { LayoutFilter } from '../_classes/LayoutFilter';

export function initLayoutFilter ($elements) {
	$elements.each((i, el) => {
		const $el = $(el);
		if ($el instanceof LayoutFilter) {
			return true;
		}
		const instance = new LayoutFilter($el);
		instance.init();
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/layout-filter.js